@if (type !== 'TIME') {
  <mat-form-field
    subscriptSizing="dynamic"
    class="w-full [&_.mat-form-field-wrapper]:p-0"
    >
    <input
      matInput
      [formControl]="control"
      type="number" />
    <!-- unit display -->
    <div matSuffix class="w-[81px] [border-left:_1px_solid] border-gray-80 pl-1 h-[1.2em] leading-[1.2em]">
      {{unit}}
    </div>
    @if(control.invalid && control.errors) {
      <mat-error>
        @switch(true) {
          @case(!!control.errors.min) {
            Minimum value is {{control.errors.min.min}}
          }
          @case(!!control.errors.max) {
            Maximum value is {{control.errors.max.max}}
          }
          @case(control.errors!.stepError) {
            Invalid step size.&nbsp;
            <a
              href="#"
            (click)="
              $event.preventDefault();
              _confirmSuggestedValue(control.errors.suggestedValue)"
              >
              Closest valid value is {{ control.errors.suggestedValue }}. (Click to accept)
            </a>
          }
          @default {
            Invalid value
          }
        }
      </mat-error>
    }
  </mat-form-field>
} @else {
  <div class="flex items-center">
    <app-simple-time-input
      class="bg-white"
      [formControl]="control" />
    <span class="
      w-[81px]
      ml-auto
      [border-left:_1px_solid] border-gray-80 
      pl-1"
      >
      hh:mm:ss
    </span>
  </div>
}

